import moment from 'moment';
import {PermissionSettings} from '../../helpers/constants';

export const dtLocal = 'YYYY-MM-DD[T]HH:mm:ss';

export const daysOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export function sortEntryTimesFn(a, b) {
  const aStart = a.newClockIn ? moment(a.newClockIn) : moment(a.ClockIn);
  const bStart = b.newClockIn ? moment(b.newClockIn) : moment(b.ClockIn);

  return moment(aStart, dtLocal).isAfter(moment(bStart, dtLocal));
}

function getDayTotal(dayEntries) {
  if (dayEntries === null || dayEntries === undefined) {
    return 0;
  }

  const minutes = dayEntries.reduce((acc, e) => {
    const notFinished =
      (e.isNew && !e.newClockOut && !e.newClockIn) ||
      (e.newClockIn && !e.newClockOut && !e.ClockOut) ||
      (e.newClockOut && !e.newClockIn && !e.ClockIn);

    if (notFinished) {
      return acc;
    }

    const start = e.newClockIn
      ? moment(e.newClockIn, dtLocal)
      : moment(e.ClockIn, dtLocal);
    const end = e.newClockOut
      ? moment(e.newClockOut, dtLocal)
      : moment(e.ClockOut, dtLocal);
    const diff = end.diff(start, 'minutes');

    return acc + diff;
  }, 0);

  return minutes;
}

export function getDayTotals(savedEntriesData, newEntries) {
  return daysOfWeek.map((day, index) => {
    if (day in savedEntriesData) {
      let dayEntries = savedEntriesData[day].Data || [];

      dayEntries = dayEntries.concat(newEntries[index]);
      dayEntries = dayEntries.filter(e => e.IsActive && !e.needsDelete);

      return getDayTotal(dayEntries);
    }

    return 0;
  });
}

function getAllEntries(savedEntries, newEntries) {
  // flatten savedEntries object into array of entries
  const allSaved = daysOfWeek.reduce((acc, d) => {
    if (!savedEntries[d] || !savedEntries[d].Data) return acc;

    return acc.concat(savedEntries[d].Data.filter(e => e));
  }, []);

  // flatten newEntries and add to saved array
  const all = newEntries.reduce((acc, d) => {
    if (!d) return acc;
    return acc.concat(d.filter(e => e));
  }, allSaved);

  return all;
}

export function findAllOverlappingTimes(savedEntries, newEntries) {
  const days = [];

  for (let x = 0; x < daysOfWeek.length; x += 1) {
    const day = daysOfWeek[x];
    let all =
      savedEntries[day] && savedEntries[day].Data !== null
        ? savedEntries[day].Data.concat(newEntries[x])
        : newEntries[x];

    if (all) {
      all = all.filter(e => e && e.IsActive && !e.needsDelete);
      all.sort(sortEntryTimesFn);

      // loop through and check clockIn not before previous clockOut
      let prev = all[0];

      for (let i = 1; i < all.length; i += 1) {
        const cur = all[i];
        const prevEnd = prev.newClockOut
          ? moment(prev.newClockOut, dtLocal)
          : moment(prev.ClockOut, dtLocal);
        const prevStart = prev.newClockIn
          ? moment(prev.newClockIn, dtLocal)
          : moment(prev.ClockIn, dtLocal);
        const currEnd = cur.newClockOut
          ? moment(cur.newClockOut, dtLocal)
          : moment(cur.ClockOut, dtLocal);
        const curStart = cur.newClockIn
          ? moment(cur.newClockIn, dtLocal)
          : moment(cur.ClockIn, dtLocal);

        // if the current falls within the previous
        if (
          (curStart >= prevStart && curStart <= prevEnd) ||
          (currEnd <= prevEnd && currEnd >= prevStart)
        ) {
          days.push(day);
        }

        // if the previous falls within the current
        if (
          (prevStart >= curStart && prevStart <= currEnd) ||
          (prevEnd <= currEnd && prevEnd >= curStart)
        ) {
          days.push(day);
        }

        if (curStart.diff(prevEnd, 'minutes') < 0) {
          days.push(day);
        }

        prev = cur;
      }
    }
  }
  const dupDaysRemoved = Array.from(new Set(days));

  return {
    hasOverlappingDayErrors: dupDaysRemoved.length,
    overlappingDays: dupDaysRemoved,
  };
}

export function hasOverlappingTimes(savedEntries, newEntries) {
  return findAllOverlappingTimes(savedEntries, newEntries);
}

export function hasInvalidTimes(savedEntries, newEntries) {
  let all = getAllEntries(savedEntries, newEntries);

  all = all.filter(e => e.IsActive && !e.needsDelete);

  const index = all.findIndex(e => {
    if (e.isNew && !e.newClockIn && !e.newClockOut) {
      return false;
    }

    if (
      (e.newClockIn && !moment(e.newStartString, 'LT').isValid()) ||
      (e.newClockOut && !moment(e.newEndString, 'LT').isValid())
    ) {
      return true;
    }

    // new entry and only 1 of 2 values is set
    if (e.isNew && (!e.newClockOut || !e.newClockIn)) {
      return true;
    }

    // existing entry with only new start
    if (!e.isNew && e.newClockIn && !e.newClockOut) {
      return e.newClockIn > e.ClockOut;
    }

    // existing entry with only new end
    if (!e.isNew && !e.newClockIn && e.newClockOut) {
      return e.ClockIn > e.newClockOut;
    }

    if (e.newClockIn && e.newClockIn) {
      return e.newClockIn > e.newClockOut;
    }

    return false;
  });

  return index !== -1;
}

export const filterPermissions = (raw, settings = PermissionSettings) =>
  Object.keys(raw)
    .filter(key => settings.includes(key))
    .reduce((obj, key) => {
      obj[key] = raw[key]; // eslint-disable-line no-param-reassign
      return obj;
    }, {});



// WEBPACK FOOTER //
// ./src/components/StaffList/staffHelpers.js